var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    stroke: "#E9E9E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1169 28C27.6045 28 27.9999 27.6046 27.9999 27.1169V12.8831C27.9999 12.3953 27.6045 12 27.1169 12H12.8831C12.3952 12 12 12.3953 12 12.8831V27.1169C12 27.6046 12.3952 28 12.8831 28H27.1169Z",
    fill: "#395185"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0377 27.9999V21.8039H25.1175L25.4288 19.3892H23.0377V17.8474C23.0377 17.1483 23.2318 16.6719 24.2344 16.6719L25.5131 16.6713V14.5116C25.2918 14.4822 24.5328 14.4164 23.6498 14.4164C21.8062 14.4164 20.5441 15.5418 20.5441 17.6084V19.3892H18.459V21.8039H20.5441V27.9999H23.0377Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookCircle);
export default __webpack_public_path__ + "static/media/facebook-circle.1311ee03d222d9e2bd9a06291abd0a0c.svg";
export { ForwardRef as ReactComponent };